import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalTelaProduto",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-content",
  style: {"border-radius":"10px","padding":"20px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  style: {"margin-bottom":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column gap-4" }, [
    /*#__PURE__*/_createElementVNode("h5", {
      class: "modal-title",
      id: "exampleModalLongTitle",
      style: {"font-size":"20px"}
    }, " Adicione, edite ou remova o produto ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn-close",
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = {
  class: "col-12 row m-0 p-0",
  style: {"gap":"0.75rem"}
}
const _hoisted_6 = { class: "row p-0 m-0 gap-3" }
const _hoisted_7 = { class: "col p-0" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_11 = { class: "row p-0 m-0 gap-3" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_16 = { class: "row p-0 m-0 gap-3" }
const _hoisted_17 = { class: "col p-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Informação extra", -1)
const _hoisted_19 = { class: "d-flex flex-column col p-0" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_21 = { class: "row p-0 m-0 gap-3" }
const _hoisted_22 = { class: "d-flex flex-column col p-0" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger fs-3"
}
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "URL video", -1)
const _hoisted_26 = { class: "row p-0 m-0" }
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "URL imagem", -1)
const _hoisted_29 = {
  class: "modal-footer gap-2 p-0 pt-5",
  style: {"border":"none"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5625 22.6563C1.5625 23.2779 1.80943 23.874 2.24897 24.3135C2.68851 24.7531 3.28465 25 3.90625 25H17.9688C18.5904 25 19.1865 24.7531 19.626 24.3135C20.0656 23.874 20.3125 23.2779 20.3125 22.6563V6.25001H1.5625V22.6563ZM14.8438 10.1563C14.8438 9.94906 14.9261 9.75034 15.0726 9.60383C15.2191 9.45732 15.4178 9.37501 15.625 9.37501C15.8322 9.37501 16.0309 9.45732 16.1774 9.60383C16.3239 9.75034 16.4062 9.94906 16.4062 10.1563V21.0938C16.4062 21.301 16.3239 21.4997 16.1774 21.6462C16.0309 21.7927 15.8322 21.875 15.625 21.875C15.4178 21.875 15.2191 21.7927 15.0726 21.6462C14.9261 21.4997 14.8438 21.301 14.8438 21.0938V10.1563ZM10.1562 10.1563C10.1562 9.94906 10.2386 9.75034 10.3851 9.60383C10.5316 9.45732 10.7303 9.37501 10.9375 9.37501C11.1447 9.37501 11.3434 9.45732 11.4899 9.60383C11.6364 9.75034 11.7188 9.94906 11.7188 10.1563V21.0938C11.7188 21.301 11.6364 21.4997 11.4899 21.6462C11.3434 21.7927 11.1447 21.875 10.9375 21.875C10.7303 21.875 10.5316 21.7927 10.3851 21.6462C10.2386 21.4997 10.1562 21.301 10.1562 21.0938V10.1563ZM5.46875 10.1563C5.46875 9.94906 5.55106 9.75034 5.69757 9.60383C5.84409 9.45732 6.0428 9.37501 6.25 9.37501C6.4572 9.37501 6.65591 9.45732 6.80243 9.60383C6.94894 9.75034 7.03125 9.94906 7.03125 10.1563V21.0938C7.03125 21.301 6.94894 21.4997 6.80243 21.6462C6.65591 21.7927 6.4572 21.875 6.25 21.875C6.0428 21.875 5.84409 21.7927 5.69757 21.6462C5.55106 21.4997 5.46875 21.301 5.46875 21.0938V10.1563ZM21.0938 1.56251H15.2344L14.7754 0.649423C14.6782 0.454215 14.5284 0.29001 14.3429 0.175281C14.1575 0.0605526 13.9437 -0.00014785 13.7256 8.5609e-06H8.14453C7.92694 -0.000827891 7.71352 0.0596463 7.52871 0.174503C7.34391 0.289359 7.19519 0.453951 7.09961 0.649423L6.64062 1.56251H0.78125C0.57405 1.56251 0.375336 1.64482 0.228823 1.79133C0.08231 1.93784 0 2.13656 0 2.34376L0 3.90626C0 4.11346 0.08231 4.31217 0.228823 4.45869C0.375336 4.6052 0.57405 4.68751 0.78125 4.68751H21.0938C21.301 4.68751 21.4997 4.6052 21.6462 4.45869C21.7927 4.31217 21.875 4.11346 21.875 3.90626V2.34376C21.875 2.13656 21.7927 1.93784 21.6462 1.79133C21.4997 1.64482 21.301 1.56251 21.0938 1.56251Z",
    fill: "#ED2B46"
  })
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.3724 4.37237L15.6276 0.627634C15.2258 0.22577 14.6807 2.97177e-06 14.1124 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V5.88759C20 5.31927 19.7742 4.77423 19.3724 4.37237ZM10 17.1429C8.42205 17.1429 7.14286 15.8637 7.14286 14.2857C7.14286 12.7078 8.42205 11.4286 10 11.4286C11.5779 11.4286 12.8571 12.7078 12.8571 14.2857C12.8571 15.8637 11.5779 17.1429 10 17.1429ZM14.2857 3.54821V8.03571C14.2857 8.33156 14.0458 8.57143 13.75 8.57143H3.39286C3.09701 8.57143 2.85714 8.33156 2.85714 8.03571V3.39286C2.85714 3.09701 3.09701 2.85714 3.39286 2.85714H13.5946C13.7367 2.85714 13.873 2.91357 13.9734 3.01406L14.1288 3.16942C14.1785 3.21916 14.218 3.27821 14.2449 3.34321C14.2719 3.4082 14.2857 3.47786 14.2857 3.54821Z",
    fill: "white"
  })
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.3724 4.37237L15.6276 0.627634C15.2258 0.22577 14.6807 2.97177e-06 14.1124 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V5.88759C20 5.31927 19.7742 4.77423 19.3724 4.37237ZM10 17.1429C8.42205 17.1429 7.14286 15.8637 7.14286 14.2857C7.14286 12.7078 8.42205 11.4286 10 11.4286C11.5779 11.4286 12.8571 12.7078 12.8571 14.2857C12.8571 15.8637 11.5779 17.1429 10 17.1429ZM14.2857 3.54821V8.03571C14.2857 8.33156 14.0458 8.57143 13.75 8.57143H3.39286C3.09701 8.57143 2.85714 8.33156 2.85714 8.03571V3.39286C2.85714 3.09701 3.09701 2.85714 3.39286 2.85714H13.5946C13.7367 2.85714 13.873 2.91357 13.9734 3.01406L14.1288 3.16942C14.1785 3.21916 14.218 3.27821 14.2449 3.34321C14.2719 3.4082 14.2857 3.47786 14.2857 3.54821Z",
    fill: "white"
  })
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir este produto?", -1)
const _hoisted_35 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.verifySelectValues && _ctx.verifySelectValues(...args))),
        class: "modal-dialog modal-lg modal-dialog-centered",
        role: "document"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Nome "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.produto,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.produto.produto) = $event)),
                  placeholder: "Nome do produto",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Preço "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.preco,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.produto.preco) = $event)),
                  modelModifiers: { lazy: true },
                  placeholder: "Preço do produto",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Estoque "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  type: "number",
                  modelValue: _ctx.produto.estoque,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.produto.estoque) = $event)),
                  placeholder: "Quantidade do produto",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Código produto loja "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.codProdutoLoja,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.produto.codProdutoLoja) = $event)),
                  placeholder: "Código do produto",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.informacao_extra,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.produto.informacao_extra) = $event)),
                  placeholder: "Info do produto",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Grupo "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: _ctx.produto.grupoExibicao,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.produto.grupoExibicao) = $event)),
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grupos, (nomeGrupo, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        label: nomeGrupo,
                        value: nomeGrupo
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Unidade "),
                  (_ctx.spanWarning == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.produto.unidade,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.produto.unidade) = $event)),
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "Uni",
                      label: "Unidade"
                    }),
                    _createVNode(_component_el_option, {
                      value: "Lt",
                      label: "Litro"
                    }),
                    _createVNode(_component_el_option, {
                      value: "Kg",
                      label: "Kilo"
                    }),
                    _createVNode(_component_el_option, {
                      value: "Granel",
                      label: "Granel"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.videoProduto,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.produto.videoProduto) = $event)),
                  placeholder: "Insira uma url",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.produto.imgProdutoUploader,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.produto.imgProdutoUploader) = $event)),
                  placeholder: "Insira uma url",
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            (!_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  text: "Excluir",
                  variant: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isCreate)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  type: "submit",
                  variant: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  type: "button",
                  variant: "secondary",
                  text: "Salvar",
                  onClick: _ctx.updateProduct
                }, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ])
      ], 32)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Confirme sua ação",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_35, [
          _createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.deleteProduct
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirmar")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_34
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}